import * as yup from "yup";

import { messagesConstants } from "@/constants";

export const loginFormLoginAuthFormSchema = yup.object({
    email: yup.string().email(messagesConstants.inputsMsgs.invalidEmail).required(messagesConstants.inputsMsgs.email),
    password: yup.string().required(messagesConstants.inputsMsgs.password),
});
